import { ReactElement } from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import { BeatLoader, ClipLoader } from 'react-spinners';

type LoaderProps = {
  size?: number;
  color?: string;
  type?: 'clip' | 'beat';
};

/**
 * Loader component.
 * @param props - Loader props.
 * @returns - React component.
 */
export default function Loader(props: LoaderProps): ReactElement {
  const { type, color = '#36d7b7', size } = props;
  return (
    <div className="absolute inset-0 bottom-0 top-0 z-10 flex justify-center items-center">
      {type === 'beat' ? (
        <BeatLoader data-testid="beat-loader" size={size} color={color} />
      ) : (
        <ClipLoader data-testid="clip-loader" color={color} size={size} />
      )}
    </div>
  );
}
